import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import RoasterDetails from './RoasterDetails';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { convertToHoursAndMinutes } from 'src/utils/pnd/PndUtilities';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import Badge from "react-bootstrap/Badge";
const HubDetailsIndex = () => {
  useEffect(() => {
    getAllDutyRoaster();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const getAllDutyRoaster = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllRiderDutyRoasterHistory();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      }
      else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };



  function calExtendedTime(timeInMilliseconds) {
    if (timeInMilliseconds) {
      // Convert milliseconds to minutes
      const timeInMinutes = Math.floor(timeInMilliseconds / 60000);

      // Calculate hours and minutes
      const totalHours = Math.floor(timeInMinutes / 60);
      const minutes = timeInMinutes % 60;

      // Convert hours to 24-hour format
      const hours = totalHours % 24;

      // Ensure hours and minutes are formatted with leading zero if needed
      const formattedHours = hours < 10 ? `0${hours}` : hours;
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

      // Combine hours and minutes into a string
      return `${formattedHours}:${formattedMinutes}`;
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },

      {
        Header: 'Rider Name',
        accessor: 'riderName',
        disableGlobalFilter: false,
      },

      {
        Header: 'Shift Name',
        accessor: 'shiftName',
        disableGlobalFilter: false,
      },

      {
        Header: 'Shift Start Time',
        accessor: 'dutyStartTime',
        disableGlobalFilter: false,
        Cell: row => {
          const startTime = convertToHoursAndMinutes(row.value);
          return <span>{startTime}</span>;
        }
      },
      {
        Header: 'Shift End Time',
        accessor: 'dutyEndTime',
        disableGlobalFilter: false,
        Cell: row => {
          const startTime = convertToHoursAndMinutes(row.value);
          return <span>{startTime}</span>;
        }

      },
      {
        Header: 'Roster Date',
        accessor: 'roasterDate',
        disableGlobalFilter: false,
      },
      // {
      //   Header: 'Roaster Status',
      //   accessor: 'roasterStatusDesc',
      //   disableGlobalFilter: false,
      // },

      {
        Header: "Roster Status",
        accessor: "roasterStatusDesc",
        disableSortBy: false,
        // width: 20,
        Cell: ({ row }) => (<>
          {row.original?.roasterStatusId === 2 ? (
            <h6><Badge bg="success">{row.original?.roasterStatusDesc}</Badge></h6>
          ) : row.original?.roasterStatusId === 8 ? (
            <h6><Badge bg="warning">{row.original?.roasterStatusDesc}</Badge></h6>
          ) : row.original?.roasterStatusId === 7 || row.original?.roasterStatusId === 7 ? (
            <h6><Badge bg="danger">{row.original?.roasterStatusDesc}</Badge></h6>
          ) : row.original?.roasterStatusId === 1 ? (
            <h6><Badge bg="primary">{row.original?.roasterStatusDesc}</Badge></h6>
          ) : <h6><Badge bg="success">{row.original?.roasterStatusDesc}</Badge></h6>}
        </>)
      },
      {
        Header: 'Absent Reason',
        accessor: 'reason',
        disableGlobalFilter: false,
      },
      {
        Header: 'Rider Requested Time',
        accessor: 'extendedTime',
        disableSortBy: true,

        Cell: row => {
          const startTime = calExtendedTime(row.value);
          return <span>{startTime === "NaN:NaN AM" ? "" : startTime}</span>;
        }
      },
      {
        Header: 'Hub Approved Time',
        accessor: 'hubApprovedHours',
        disableSortBy: true,

        Cell: row => {
          const startTime = calExtendedTime(row.value);
          return <span>{startTime === "NaN:NaN AM" ? "" : startTime}</span>;
        }
      },

    ],
    [],
  );



  return (
    <Container>

      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <RoasterDetails reactTableData={reactTableData} />}
      {isNoRecordFound && <SnackbarContent message={'No Records Found'} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}




    </Container>
  );
};

export default HubDetailsIndex;